import {formatTime} from "@/libs/helper";

export const UhfCanteenHeader: React.FC<any> = ({headerData}) => {
  return (
    <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
      {headerData &&
        Object.entries(headerData).map(([label, timeRange]) => {
          const [start, end] = timeRange as number[];
          return (
            <div key={label} className="flex items-center gap-2 capitalize">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path
                  fillRule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="font-semibold">{label}</span>
              <span>
                {formatTime(start)} - {formatTime(end)}
              </span>
            </div>
          );
        })}
    </div>
  );
};
